import React, { useState, useEffect } from "react";
import "./customer_dashboard2.css";
import "./customer_dashboard.css";
import TopNav from "../../TopNav/TopNav";
// import Header from "../../Header/Header";
import NewHeader from "../../NewHeader/NewHeader";
import ScrolltoTop from "../../Scrolltotop/ScrolltoTop";
import Footer from "../../Footer/Footer";

import SubFooter from "../../SubFooter/SubFooter";
import { useDispatch, useSelector } from "react-redux";
import { downloadReport, getCustomerDashboard } from "../../../Redux/Actions";
import Axios from "../../../config/Axios";
import Prefix from "../../../config/ApiPrefix";
import { Scroll } from "../../Scroll function/scroll";
import { Modal } from "react-responsive-modal";
import ProfileEditForm from "../../Form/EditForm";

function MyBookings() {
  useEffect(() => {
    Scroll();
  }, []);

  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const dispatch = useDispatch();

  const BookingDetails = useSelector((state) => state.customerBookingDetails);

  const Editprofile = useSelector((state) => state.EditProfile);

  const { customerDetailResponse, loading } = BookingDetails;

  const downloadReportResponse = useSelector(
    (state) => state.downloadReportResponse
  );

  console.log(downloadReportResponse, BookingDetails, "hjgjjkk");

  const CustomerDetails = useSelector((state) => state.customerDashboard);

  const UserProfile = CustomerDetails.packages.profile;

  console.log(UserProfile);

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;

    if (!UserProfile) {
      setTimeout(() => {
        dispatch(getCustomerDashboard(token));
      }, 500);
    }
  }, [UserProfile]);

  try {
    if (JSON.parse(localStorage.getItem("user"))) {
      const userFromLocal = JSON.parse(localStorage.getItem("user"));
      var token = userFromLocal.token;
      var usernumber = userFromLocal.username;
    }
  } catch (error) {}

  useEffect(() => {
    if (customerDetailResponse && customerDetailResponse.results) {
      localStorage.setItem(
        "MyBookings",
        JSON.stringify(customerDetailResponse.results)
      );
    }
  }, []);

  const [result, setResult] = useState([]);
  useEffect(() => {
    if (localStorage.getItem("MyBookings")) {
      const MyBooking = JSON.parse(localStorage.getItem("MyBookings"));
      setResult(MyBooking);
    } else {
      setResult([]);
    }
  }, []);
  console.log(customerDetailResponse);
  console.log("from localstorage", result);
  const [error, setError] = useState("");
  const [show1, setShow1] = useState(true);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [isActive1, setisActive1] = useState(true);
  const [isActive2, setisActive2] = useState(false);
  const [isActive3, setisActive3] = useState(false);

  const userProfile = () => {
    setisActive1(true);
    setisActive2(false);
    setisActive3(false);

    setShow1(true);
    setShow2(false);
    setShow3(false);
  };
  const userBookings = () => {
    setisActive1(false);
    setisActive2(true);
    setisActive3(false);
    setShow1(false);
    setShow2(true);
    setShow3(false);
  };
  const userReports = () => {
    setisActive1(false);
    setisActive2(false);
    setisActive3(true);
    setShow1(false);
    setShow2(false);
    setShow3(true);
  };

  const DownloadReport = (string, name, date) => {
    var b64 = string;
    console.log("bs string i want", b64);
    var bin = window.atob(b64);
    console.log("File Size:", Math.round(bin.length / 1024), "KB");
    console.log("PDF Version:", bin.match(/^.PDF-([0-9.]+)/)[1]);

    // Insert a link that allows the user to download the PDF file
    var link = document.createElement("a");
    // link.innerHTML = 'Download PDF file';
    link.download = `${name}-${date}.pdf`;
    link.href = "data:application/octet-stream;base64," + b64;
    // window.document.getElementsByClassName(".letsdownl").innerHTML=link
    link.click();
  };

  const ViewReport = (string, name, date) => {
    var b64 = string;
    console.log("bs string i want", b64);
    var bin = window.atob(b64);
    console.log("File Size:", Math.round(bin.length / 1024), "KB");
    console.log("PDF Version:", bin.match(/^.PDF-([0-9.]+)/)[1]);
    // console.log('Create Date:', bin.match(/<xmp:CreateDate>(.+?)<\/xmp:CreateDate>/)[1]);
    // console.log('Modify Date:', bin.match(/<xmp:ModifyDate>(.+?)<\/xmp:ModifyDate>/)[1]);
    // console.log('Creator Tool:', bin.match(/<xmp:CreatorTool>(.+?)<\/xmp:CreatorTool>/)[1]);

    // Embed the PDF into the HTML page and show it to the user
    var obj = document.createElement("object");
    obj.style.width = "100%";
    obj.style.height = "842pt";
    obj.type = "application/pdf";
    obj.data = "data:application/pdf;base64," + b64;

    // document.body.appendChild(obj);
    // window.open("data:application/pdf;base64, " + obj);

    // testing
    let pdfWindow = window.open("");
    pdfWindow.document.write(
      "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(b64) +
        "'></iframe>"
    );

    // Insert a link that allows the user to download the PDF file
    // var link = document.createElement('a');
    // link.innerHTML = 'Download PDF file';
    // link.download = `${name}-${date}.pdf`;
    // link.href = 'data:application/octet-stream;base64,' + b64;
    // window.document.getElementsByClassName(".letsdownl").innerHTML=link
    // link.click();
  };

  return (
    <div>
      {/* <TopNav /> */}
      <NewHeader />

      <div className="mainContent">
        <div className="mainContent_left__sideBar  ">
          <div
            className={
              isActive1 ? "Dashboard_content active__div " : "Dashboard_content"
            }
            onClick={userProfile}
          >
            <span>User Profile</span>
          </div>
          <div
            className={
              isActive2 ? "Dashboard_content active__div " : "Dashboard_content"
            }
            onClick={userBookings}
          >
            <span>Bookings</span>
          </div>
          {/* <div className={isActive3 ? "Dashboard_content active__div " : "Dashboard_content"} onClick={userReports}>
            <span>Reports</span>
          </div> */}
        </div>
        <div className="mainContent_right__sideBar  ">
          {show1 ? (
            <div className="UserProfile__div">
              <div className="UserProfile__Details" style={{ border: "none" }}>
                <div className="UserProfile__Details__name">
                  <label>Name : </label>
                  {UserProfile && <span>{UserProfile.fullname}</span>}
                </div>

                <div className="UserProfile__Details__name">
                  <label>Phone number : </label>
                  {UserProfile && <span>{UserProfile.phonenumber}</span>}
                </div>

                <div className="UserProfile__Details__name">
                  <label>Age : </label>
                  {UserProfile && <span>{UserProfile.age}</span>}
                </div>

                <div className="UserProfile__Details__name">
                  <label>Email : </label>
                  {UserProfile && <span>{UserProfile.email}</span>}
                </div>

                <div className="UserProfile__Details__name">
                  <label>Address : </label>
                  {UserProfile && <span>{UserProfile.address}</span>}
                </div>
                <button onClick={onOpenModal} className="EditProfile__Button">
                  Edit Profile
                </button>
                <Modal
                  open={open}
                  onClose={onCloseModal}
                  center
                  classNames={{
                    overlay: "customOverlay",
                    modal: "customModal",
                  }}
                >
                  <ProfileEditForm
                    userDetail={UserProfile}
                    close={onCloseModal}
                  />
                </Modal>
              </div>
            </div>
          ) : null}
          {/***Booking Div */}
          {show2 ? (
            <div className="scroll_overflow">
              {result.length > 0 ? (
                result.map((values) => (
                  <div className="Bookings__div">
                    <div className="Booking__top" style={{ border: "none" }}>
                      <div className="Booking__leftside">
                        <span className="Booking__leftside__BookingId">
                          Booking ID : {values.pk}
                        </span>
                        <button
                          onClick={() => {
                            const config = {
                              headers: {
                                Authorization: `Token ${token}`,
                              },
                            };

                            Axios.get(
                              `${Prefix.api}/booking/report_status/${values.pk}/`,
                              config
                            ).then(({ data }) => {
                              try {
                                if (
                                  data.allReportDetails &&
                                  data.allReportDetails.reportDetails
                                ) {
                                  DownloadReport(
                                    data.allReportDetails.reportDetails,
                                    values.customer_name,
                                    values.collection_date
                                  );
                                } else if (data.error) {
                                  alert("Report is not available");
                                } else if (data.message) {
                                  alert(data.message);
                                }
                              } catch (err) {
                                console.log(err);
                              }
                            });

                            // }catch(e){
                            //   alert(e.message)
                            // }finally{
                            //   alert('report is not ready yet')
                            // }

                            // DownloadReport()
                            // setTimeout(() => {DownloadReport()},8000)
                          }}
                        >
                          Download Report
                        </button>
                        <button
                          onClick={() => {
                            const config = {
                              headers: {
                                Authorization: `Token ${token}`,
                              },
                            };

                            Axios.get(
                              `${Prefix.api}/booking/report_status/${values.pk}/`,
                              config
                            ).then(({ data }) => {
                              try {
                                if (
                                  data.allReportDetails &&
                                  data.allReportDetails.reportDetails
                                ) {
                                  ViewReport(
                                    data.allReportDetails.reportDetails,
                                    values.customer_name,
                                    values.collection_date
                                  );
                                } else if (data.error) {
                                  alert("Report is not available");
                                } else if (data.message) {
                                  alert(data.message);
                                }
                              } catch (err) {
                                console.log(err);
                              }
                            });

                            // }catch(e){
                            //   alert(e.message)
                            // }finally{
                            //   alert('report is not ready yet')
                            // }

                            // DownloadReport()
                            // setTimeout(() => {DownloadReport()},8000)
                          }}
                        >
                          View Report
                        </button>
                        <div className="letsdownl">{/* <h1>Hello</h1> */}</div>
                      </div>
                    </div>
                    <div className="Bookings__content">
                      <div className="Bookings__contentLeft">
                        <span>Date: {values.booking_date}</span>
                        <span>Name: {values.customer_name}</span>
                        <span>Age: {values.customer_age}</span>
                        <span>Gender: {values.customer_gender}</span>
                      </div>
                      <div className="Bookings__contentRight ">
                        <h5>Payment details</h5>
                        <span>{values.discounted_price.final_total_price}</span>
                      </div>
                    </div>
                    <div className="Package_details">
                      <div>
                        <div className="package_data">
                          <table
                            border="1"
                            cellSpacing="5"
                            style={{ border: "none" }}
                          >
                            <th>
                              <tr>
                                <td>package name</td>
                                <td>package addon price </td>
                                <td> package offerprice </td>
                                <td> package price</td>
                              </tr>

                              {values.packages.map((packages) => (
                                <tr key={packages.id}>
                                  <td>{packages.name}</td>
                                  <td>{packages.addon_price}</td>{" "}
                                  <td>{packages.offer_price}</td>
                                  <td>{packages.package_price}</td>
                                </tr>
                              ))}
                            </th>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <h1>No Bookings Yet</h1>
              )}
            </div>
          ) : null}
          {show3 ? (
            <div className="Reports__div">
              <h1> No Reports Yet!!!</h1>
            </div>
          ) : null}
        </div>
      </div>
      <ScrolltoTop />
      <Footer />
      <SubFooter />
    </div>
  );
}
export default {
  component: MyBookings,
};
